export default {
    mensajes: {
      inicial: '¡Hola!',
      descripcion: 'En tres pasos, podrás solicitar tu presupuesto de forma sencilla y rápida.',
      resumen: 'Ver Resumen',
      cuestionario: {
        titulo: 'Cuéntanos tu experiencia',
        introduccion: 'Tu opinión nos ayuda a mejorar y a cuidar la calidad de cada servicio de tu viaje.',
        cargando: 'Estamos preparando tu cuestionario…',
        enlace_invalido: 'Este enlace no corresponde a ninguna reserva.',
        error_carga: 'No hemos podido cargar el cuestionario. Inténtalo de nuevo más tarde.',
        error_envio: 'No hemos podido enviar tus respuestas. Inténtalo de nuevo.',
        no_disponible: 'El cuestionario estará disponible cuando finalice tu viaje.',
        disponible_desde: 'Podrás completarlo a partir del {fecha}.',
        sin_preguntas: 'No hay preguntas disponibles para los servicios de esta reserva.',
        gracias: '¡Gracias por compartir tu experiencia!',
        enviado_correctamente: 'Tus respuestas se han guardado correctamente.',
        bloques_guardados: 'Se ha guardado 1 valoración. Puedes completar las restantes. | Se han guardado {count} valoraciones. Puedes completar las restantes.',
        comentario: '¿Quieres contarnos algo más? (opcional)',
        de_diez: 'de 10',
        enviar: 'Enviar mis respuestas',
        responde_una: 'Responde al menos una pregunta para poder enviar.',
        secciones: {
          rutas_meigas: 'Rutas Meigas',
          alojamientos: 'Alojamientos',
          servicios: 'Servicios',
        },
        tipos: {
          general: 'Rutas Meigas',
          alojamiento: 'Alojamiento',
          servicio: 'Servicio',
        },
      },
      login: {
        agencias: 'AGENCIAS',
        trabaja_con_nosotros: '¿Quieres trabajar con nosotros como agencia?',
        descripcion_registro: 'Déjanos tus datos y te contactaremos para gestionar el alta de tu agencia.',
        contactar: 'Contactar',
        agencia_requerida: 'Agencia (*)',
        responsable_requerido: 'Responsable (*)',
        email_requerido: 'Email (*)',
        telefono_requerido: 'Teléfono (*)',
        mensaje_opcional: 'Mensaje (Opcional)',
        solicitud_enviada: 'Solicitud enviada correctamente. Te contactaremos pronto. Gracias por tu interés.',
        enviando: 'Enviando...',
        enviar_solicitud: 'Enviar solicitud',
        agencia_registrada: '¿Ya eres una agencia registrada?',
        accede_con_tus_datos: 'Accede con tus datos',
        nombre: 'Nombre',
        contrasena: 'Contraseña',
        accediendo: 'Accediendo...',
        acceder: 'Acceder',
        error_campos_obligatorios: 'Debes completar agencia, responsable, correo y teléfono.',
        error_email_invalido: 'El correo no tiene un formato válido.',
        error_solicitud: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
      },
      central_reservas: {
        nueva_solicitud: 'Nueva solicitud',
        expedientes_menu: 'Expedientes',
        expedientes: 'Expedientes',
        proformas: 'Proformas',
        invoices_menu: 'Proformas',
        perfil_agencia: 'Perfil de agencia',
        ayuda: 'Ayuda',
        cerrar_sesion: 'Cerrar sesión',
        selecciona_camino: 'Selecciona un camino',
        selecciona_agencia_origen: 'Selecciona la agencia de origen',
        idioma_documentacion: 'Idioma de la documentación de la reserva',
      idioma_es: 'Español',
      idioma_en: 'Inglés',
      idioma_de: 'Alemán',
      cambiar_idioma: 'Cambiar idioma',
        nombre_agencia: 'Nombre de la agencia',
        telefono_agencia: 'Teléfono de la agencia',
        email_agencia: 'Email de la agencia',
        instrucciones_cliente: 'Por favor, rellena a continuación los datos de tu cliente.\n\nAl solicitar la propuesta, se enviará el presupuesto al correo electrónico de la agencia y también al email del cliente.',
        instrucciones_cliente_pendientes: 'Al solicitar la propuesta, se enviará el presupuesto al correo electrónico de la agencia y, a la mayor brevedad, el equipo de Rutas te hará llegar la propuesta completa con los servicios pendientes de cotizar.\n\nPor favor, rellena a continuación los datos de tu cliente.',
        nombre_cliente: 'Nombre del cliente',
        apellidos_cliente: 'Apellidos del cliente',
        email_cliente: 'Email del cliente',
        aviso_cliente_servicios_pendientes: '*Ten en cuenta que, al haber servicios extras pendientes de cotizar, el cliente no recibirá copia de esta solicitud.',
        enviar_propuesta_cliente: 'Enviar propuesta al cliente',
        recibir_propuesta: 'Recibir propuesta',
        expedientes: {
          refrescar: 'Refrescar',
          reservas_por_pagina: 'Reservas por página',
          codigo: 'Código',
          referencia_agencia: 'Ref. agencia',
          fecha_inicio: 'Fecha inicio',
          fechas_camino: 'Fechas Camino',
          estado: 'Estado',
          cliente: 'Cliente',
          cliente_camino: 'Cliente / Camino',
          solicitud: 'Solicitud',
          peregrinos: 'Peregrinos',
          peregrinos_corto: 'Pax',
          habitaciones: 'Habitaciones',
          habitaciones_corto: 'Hab.',
          ver_detalle: 'Ver detalle',
          sin_datos: 'No hay datos disponibles',
          cargando_detalle: 'Cargando detalle de la reserva...',
          detalle_reserva: 'Detalle de reserva',
          ver_historial: 'Ver historial',
          agente_asignado: 'Agente asignado',
          agente: 'Agente',
          codigo_interno: 'Código interno',
          inicio: 'Inicio',
          llegada: 'Llegada',
          idioma: 'Idioma',
          editar: 'Editar',
          cancelar: 'Cancelar',
          guardar: 'Guardar',
          cliente_actualizado: 'Datos del cliente actualizados correctamente.',
          importe_reserva_pvp: 'Importe reserva (PVP)',
          comision_agencia: '15% Comisión Agencia',
          importe_neto_agencia: 'Importe neto agencia',
          servicios_agregados_neto: 'Servicios agregados (Neto)',
          importe_total_pvp: 'Importe total (PVP)',
          importe_total_neto: 'Importe total (Neto)',
          pasajeros: 'Pasajeros',
          modificar_pasajeros: 'Modificar pasajeros',
          sin_pasajeros: 'No hay pasajeros registrados para esta reserva',
          archivos_reserva: 'Archivos de la reserva',
          archivos_seleccionados: '0 seleccionados | 1 seleccionado | {count} seleccionados',
          enviar_archivos: 'Enviar archivos',
          fecha: 'Fecha',
          documento: 'Documento',
          nombre: 'Nombre',
          tipo_documento: 'Tipo doc.',
          numero_documento: 'N.º doc.',
          movil: 'Móvil',
          ver: 'Ver',
          enviar: 'Enviar',
          enviar_cliente: 'Enviar al cliente',
          solicitar_modificacion: 'Solicitar modificación',
          solicitar_confirmacion: 'Solicitar confirmación',
          sin_archivos: 'No hay archivos en esta sección',
          error_cargar_detalle: 'No se pudo cargar el detalle de la reserva.',
          correo_enviado: 'Correo enviado correctamente.',
          documentos_seleccionados: 'Documentos seleccionados',
          para: 'Para',
          asunto: 'Asunto',
          texto_correo: 'Texto del correo',
          mensaje_agencia: 'Mensaje para enviar a agencia',
          detalle_correo: 'Detalle del correo',
          documentos_adjuntos: 'Documentos adjuntos',
          historial_reserva: 'Historial de la reserva',
          usuario: 'Usuario',
          descripcion: 'Descripción',
          mensaje: 'Mensaje',
          adjunto: 'Adjunto',
          sin_estado: 'SIN ESTADO',
          historial_agencia_rutas: 'Historial {agencia} <=> Rutas Meigas',
          historial_agencia_cliente: 'Historial {agencia} <=> Cliente',
          ver_documento: 'Ver documento',
          sin_acciones_historial: 'No hay acciones registradas en el historial',
        },
        invoices: {
          titulo: 'Facturas',
          descripcion: 'Listado de facturas emitidas para la agencia.',
          registros: '0 registros | 1 registro | {count} registros',
          sin_facturas: 'No hay facturas disponibles para esta agencia.',
          filtrar_fecha: 'Filtrar fecha',
          filtrar_expediente: 'Filtrar expediente',
          filtrar_documento: 'Filtrar documento',
          fecha: 'Fecha',
          expediente: 'Expediente',
          tipo: 'Tipo',
          factura: 'FACTURA',
          ver: 'Ver',
          error_agencia: 'No se pudo identificar la agencia para cargar las facturas.',
          error_carga: 'No se pudieron cargar las facturas. Inténtalo de nuevo.',
        },
        perfil: {
          titulo: 'Perfil de agencia', descripcion: 'Información de la agencia asociada al usuario autenticado.', agencia_activa: 'Agencia activa', refrescar: 'Refrescar', guardar: 'Guardar', sin_agencia: 'No se puede guardar sin identificar la agencia.', aviso_completar: 'Se necesita completar todos los datos del perfil de agencia antes de continuar.', cambiar_logo: 'Cambiar logo', campo_obligatorio: 'Campo obligatorio', comision: 'Comisión', datos_generales: 'Datos generales', nombre: 'Nombre', responsable: 'Responsable', telefono_2: 'Teléfono 2', direccion: 'Dirección', codigo_postal: 'Código postal', poblacion: 'Población', provincia: 'Provincia', pais: 'País', datos_fiscales: 'Datos fiscales', nombre_fiscal: 'Nombre fiscal', direccion_fiscal: 'Dirección fiscal', codigo_postal_fiscal: 'Código postal fiscal', poblacion_fiscal: 'Población fiscal', provincia_fiscal: 'Provincia fiscal', pais_fiscal: 'País fiscal', usuarios_asociados: 'Usuarios asociados', sin_usuarios: 'No hay usuarios asociados.', caminos_permitidos: 'Caminos permitidos', camino: 'Camino', sin_caminos: 'No hay caminos asociados.', error_refrescar: 'No se pudo refrescar el perfil de agencia. Inténtalo de nuevo.', exito_guardar: 'Perfil de agencia guardado correctamente.', error_guardar: 'No se pudo guardar el perfil de agencia. Inténtalo de nuevo.', error_imagen_invalida: 'El archivo seleccionado no es una imagen válida.', error_procesar_imagen: 'No se pudo procesar la imagen seleccionada.'
        },
        ayuda_contenido: {
          titulo: 'Centro de ayuda', descripcion: 'Encuentra respuestas rápidas por tema o busca en preguntas frecuentes.', buscar: 'Buscar en ayuda', temas: 'Temas de ayuda', preguntas: '0 preguntas | 1 pregunta | {count} preguntas', mas_ayuda: '¿Necesitas más ayuda?', contacto: 'Si no encuentras la respuesta, puedes consultarnos en este correo.', general: 'General', general_descripcion: 'Información general sobre el funcionamiento de la aplicación.', solicitudes: 'Nueva solicitud', solicitudes_descripcion: 'Creación de reservas, fechas, habitaciones y tarifas.', expedientes: 'Expedientes', expedientes_descripcion: 'Consulta, filtros y estados de reservas existentes.', cuenta: 'Cuenta y acceso', cuenta_descripcion: 'Inicio de sesión, perfil de agencia y seguridad.', video_tutorial: 'Vídeo tutorial', video_ayuda: 'Vídeo de ayuda', preguntas_frecuentes: 'Preguntas frecuentes', sin_resultados: 'No se encontraron preguntas para los filtros seleccionados.',
          faqs: {
            general: {
              1: { pregunta: '¿Qué módulos incluye el Centro de Reservas?', respuesta: '<p>La aplicación se organiza por módulos como ayuda, nueva solicitud, expedientes y cuenta/acceso.</p><p>Cada uno agrupa funciones concretas del trabajo diario.</p>' },
              2: { pregunta: '¿Cómo encuentro rápidamente una funcionalidad dentro de la aplicación?', respuesta: '<p>Usa el menú lateral para cambiar de módulo.</p><p>En el centro de ayuda encontrarás vídeos y preguntas frecuentes específicas de cada área.</p>' },
              3: { pregunta: '¿Qué hago si un listado o formulario no muestra la información esperada?', respuesta: '<p>Revisa primero:</p><ul><li>Filtros activos</li><li>Paginación actual</li><li>Campos obligatorios pendientes</li></ul><p>Si el problema persiste, contacta con soporte indicando agencia, módulo y contexto del error.</p>' }
            },
            solicitudes: {
              1: { pregunta: '¿Qué campos son obligatorios para crear una solicitud?', respuesta: '<p>Debes completar camino, idioma, fecha, habitaciones, peregrinos y el campo <strong>Código de la reserva en la Agencia</strong>.</p>' },
              2: { pregunta: '¿Cuándo se recalculan las tarifas?', respuesta: '<p>Las tarifas se recalculan automáticamente cuando cambias:</p><ul><li>Camino</li><li>Fechas</li><li>Cantidades de habitaciones</li></ul>' },
              3: { pregunta: '¿Por qué no me deja avanzar al siguiente paso?', respuesta: '<p>Normalmente ocurre por una de estas razones:</p><ul><li>Falta un campo obligatorio</li><li>No hay una distribución válida entre habitaciones y peregrinos</li></ul>' },
              4: { pregunta: '¿Cómo se reparte correctamente el número de habitaciones?', respuesta: '<p>La suma de habitaciones debe ser coherente con el número de peregrinos.</p><p>Si la distribución no cuadra, el sistema no permitirá continuar al siguiente paso.</p>' },
              5: { pregunta: '¿Puedo editar una solicitud antes de enviarla?', respuesta: '<p>Sí. Mientras no confirmes el último paso puedes:</p><ul><li>Volver atrás</li><li>Cambiar fechas</li><li>Modificar habitaciones</li><li>Actualizar datos del cliente</li></ul>' },
              6: { pregunta: '¿Qué ocurre si no aparece disponibilidad o precio?', respuesta: '<p>Suele deberse a una combinación no válida de fechas, ocupación o servicios.</p><p>Revisa el camino, el idioma y la distribución de habitaciones antes de volver a intentarlo.</p>' }
            },
            expedientes: {
              1: { pregunta: '¿Qué filtros puedo usar en Expedientes?', respuesta: '<p>Puedes filtrar por:</p><ul><li>Código</li><li>Código Agencia</li><li>Fecha inicio</li><li>Estado</li><li>Cliente</li><li>Solicitud</li><li>Peregrinos</li><li>Habitaciones</li></ul>' },
              2: { pregunta: '¿Qué significa el estado de una reserva?', respuesta: '<p>El estado indica su etapa operativa, por ejemplo <strong>SOLICITADA</strong>, <strong>PRESUPUESTADA</strong> o <strong>CONFIRMADA</strong>.</p><p>Además se muestra con su color correspondiente en la tabla y en el detalle.</p>' },
              3: { pregunta: '¿Por qué no veo algunas reservas?', respuesta: '<p>El listado aplica reglas por origen del usuario logueado.</p><p>Si eres agencia, solo verás reservas de tu propio origen.</p>' },
              4: { pregunta: '¿Cómo se aplican los filtros de la tabla?', respuesta: '<p>Cada columna dispone de su propio filtro.</p><p>Al pulsar <strong>Enter</strong> o limpiar el campo con el icono <strong>clear</strong>, el listado vuelve a consultar el endpoint con los parámetros actualizados.</p>' },
              5: { pregunta: '¿Cómo funciona la ordenación de columnas?', respuesta: '<p>Puedes ordenar por:</p><ul><li>Código</li><li>Ref. agencia</li><li>Fechas camino</li><li>Estado</li><li>Cliente</li><li>Solicitud</li><li>Peregrinos</li><li>Habitaciones</li></ul><p>La ordenación se hace contra el servidor.</p>' },
              6: { pregunta: '¿Qué hago si abro un detalle y quiero volver al listado?', respuesta: '<p>Cierra el diálogo del detalle para seguir trabajando en la tabla.</p><p>Los filtros, la paginación y la ordenación del listado se conservan.</p>' }
            },
            cuenta: {
              1: { pregunta: '¿Cómo cierro sesión de forma segura?', respuesta: '<p>Usa la opción <strong>Cerrar sesión</strong> del menú lateral.</p><p>Esto invalida tu sesión y vuelve a la pantalla de login.</p>' },
              2: { pregunta: '¿Qué hago si olvidé mis credenciales?', respuesta: '<p>Contacta con administración para restablecer acceso.</p><p>Indica agencia, email y teléfono de contacto.</p>' },
              3: { pregunta: '¿Dónde puedo revisar o actualizar los datos de mi agencia?', respuesta: '<p>Desde el módulo de perfil de agencia puedes revisar:</p><ul><li>Información principal</li><li>Logo</li><li>Otros datos asociados a tu cuenta</li></ul>' },
              4: { pregunta: '¿Por qué mi sesión puede cerrarse automáticamente?', respuesta: '<p>Por seguridad, la sesión puede expirar tras un tiempo de inactividad o si el token deja de ser válido.</p><p>En ese caso tendrás que iniciar sesión de nuevo.</p>' },
              5: { pregunta: '¿A quién contacto si detecto un problema técnico?', respuesta: '<p>Puedes escribir a <strong>sistemas@rutasmeigas.com</strong>.</p><p>Indica agencia, reserva afectada si aplica y una descripción breve del problema.</p>' }
            }
          }
        },
      },
     
      datos_de_reserva: 'Datos de reserva',
      datos_personales: 'Datos personales',
      resumen_reserva: 'Presupuesto enviado',

      preguntaPaso1: 'Necesitamos los datos básicos para gestionar el camino, como son: fecha de llegada, cantidad de peregrinos y cantidad de habitaciones por tipo.',
      datos_reserva: {
        fechas_seleccion: 'Fecha de llegada y salida',

        habitaciones_individuales: 'Habitaciones Individuales',
        habitaciones_dobles: 'Habitaciones Dobles (2_camas_individuales)',
        habitaciones_dobles_matrimoniales: 'Habitaciones Dobles (cama_matrimonial)',
        habitaciones_triples: 'Habitaciones Triples',
        cantidad_de_peregrinos: 'Cantidad de peregrinos',

        titulo: 'Datos de la reserva',
        fecha_inicio: 'Fecha de llegada:',
        fecha_llegada: 'Fecha de salida:',
        habitaciones: 'Habitaciones:',
        peregrinos: 'Peregrinos:',
        comentarios: 'Cuéntanos cualquier detalle adicional.\n¿Vienes con niños? Dinos sus edades.\n¿Traes mascotas? Indícanos qué mascota es y su peso.',
      
        importe_reserva: 'Importe reserva:',
        servicios_agregados: 'Servicios agregados:',
        importe_total: 'Importe total:',
        comision_agencia: '15% Comisión Agencia:',
        importe_neto_agencia: 'Importe Neto Agencia:',
        no_comisionable: '(No comisionable)',
        precio_por_peregrino: '€/Peregrino',
      },

      servicios: {
        tab_servicios: 'Servicios',
        incluidos_titulo: 'Servicios incluidos',
        incluidos_subtitulo: 'Si quieres cancelar alguno de los servicios incluidos, puedes eliminarlo.',
        opcionales_titulo: 'Servicios opcionales',
        pendiente_de_tarifa: 'Pendiente de tarifa',
        subtitulo_desde: '(Desde {tarifa}€)',
        subtitulo_por_persona: '({tarifa}€ x persona)',
        subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} personas)',
        noche_extra_en: 'Noche extra en',
        traslado_extra: 'Traslado extra',
        servicio_extra: 'Servicio extra',
        ver_incluidos_boton: 'Ver servicios incluidos',
      },

      siguientePaso1: 'Siguiente',

      preguntaPaso2: 'Ahora, necesitamos tus datos para poder enviarte el presupuesto lo antes posible.',
      nombre: 'Nombre',
      apellidos: 'Apellidos',
      telefono: 'Teléfono',
      email: 'Email',

      politica_privacidad: 'He leído y acepto la ',
      politica_privacidad_texto_enlace: 'política de privacidad',
      politica_privacidad_enlace: 'https://rutasmeigas.com/es/politica-privacidad',

      acepta_novedades: 'Acepto recibir noticias y novedades.',
      
      recibir_presupuesto: 'Recibir presupuesto',
      enviando_presupuesto: 'Enviando presupuesto...',
      presupuesto_enviado: 'Presupuesto enviado!',
      
      
    registro_individual: {"titulo": "Registro de viajero", "reserva": "Reserva", "descripcion": "Completa tus datos personales para preparar tu viaje.", "completado": "Tus datos se han guardado. Puedes consultarlos aquí.", "guardar": "Guardar mis datos", "cargando": "Cargando", "reintentar": "Reintentar", "recargar": "Recargar formulario", "noDisponible": "Este enlace no está disponible.", "errorCarga": "No se ha podido cargar el registro.", "errorEnvio": "No se han podido guardar los datos. Revisa los campos o inténtalo de nuevo.", "obligatorio": "Campo obligatorio", "email": "Indica un correo válido", "fecha": "Indica una fecha real no futura (DD/MM/YYYY)"},
    datos_pasajeros: {
      conflicto_guardado: 'Los datos de los viajeros han cambiado desde que abriste el formulario. Recarga la página antes de guardar. Tus cambios todavía no se han guardado.',
      error_guardado: 'No se han podido guardar los datos. Inténtalo de nuevo.',
      titulo: 'De acuerdo la legislación actual española (Real Decreto 933/2021 de 26 de octubre) por la que se establecen las obligaciones de registro documental e información de personas físicas o jurídicas que ejercen actividades de hospedaje (agencias de viajes, establecimientos hoteleros y empresas de alquiler de vehículos) debemos facilitar los siguientes datos al Ministerio del Interior (Gobierno de España).',
      subtitulo: 'Para gestionar tu reserva, necesitamos los datos completos de todos los peregrinos que realizarán el Camino de Santiago. Por favor, rellena cada formulario con la información solicitada.<br>Es importante que los datos sean precisos y estén completos, ya que los utilizaremos para la organización del viaje, la reserva de alojamientos y otros servicios.<br>Una vez hayas completado toda la información, procederemos a confirmar tu reserva. Si tienes alguna duda, no dudes en contactarnos.',
      datos_peregrino: 'Viajero {index}',
      confirmar_datos: 'Confirmar datos',
      guardar_datos: 'Guardar datos de los viajeros',
      mensaje_final_success: 'Gracias. Los datos de los viajeros han sido guardados correctamente.',
      pagar: 'Pagar',
      mensaje_confirmacion_pasajero_y_pago: 'Sus datos han sido enviados correctamente. Le informamos que el importe total de la reserva es de {importe} €.<br>Ya puede efectuar un pago anticipado de la reserva de 100€.',
      pago_realizado: 'Pago realizado correctamente',

      nombre: 'Nombre',
      primer_apellido: 'Primer Apellido',
      segundo_apellido: 'Segundo Apellido',
      sexo: 'Sexo',
      sexo_opciones: {
        hombre: 'Hombre',
        mujer: 'Mujer',
        no_decir: 'Prefiero no decirlo',
      },
      fecha_nacimiento: 'Fecha de Nacimiento',
      tipo_documento: 'Tipo de Doc.',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'PASAPORTE',
      },
      numero_documento: 'Número de Documento',
      soporte_documento: 'Soporte de Documento',
      telefono_fijo: 'Teléfono Fijo',
      telefono_movil: 'Teléfono Móvil',
      email: 'Email',
      direccion: 'Dirección',
      poblacion: 'Población',
      provincia: 'Provincia',
      codigo_postal: 'Código Postal',
      nacionalidad: 'Nacionalidad',
      parentesco: 'Parentesco',
     

      pago_realizado_subtitulo: 'Gracias por confiar en nosotros.<br>Nos pondremos en contacto contigo para confirmar los detalles de tu reserva.',
      politica_privacidad: `Responsable del tratamiento: RUTAS MEIGAS SL CIF: B15649270 Dir. Postal: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Teléfono: 881019941 Correo electrónico: info@rutasmeigas.com 
Finalidad del tratamiento de sus datos: De acuerdo a lo establecido en la legislación vigente en materia de Protección de Datos de Carácter Personal, Reglamento 2016/679 General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de 5 de diciembre, de protección de datos de carácter personal y garantía de los derechos digitales (LOPDGDD), le indicamos que la finalidad del tratamiento de sus datos es llevar a cabo la gestión de su reserva.
Legitimación: Artículo 6.1.a) del RGPD. El interesado dio su consentimiento para el tratamiento de sus datos personales para uno o varios fines específicos. Artículo 6.1.b) del RGPD. Tratamiento necesario para la ejecución de un contrato en el que el interesado es parte o para la aplicación a petición de éste de medidas precontractuales. Artículo 6.1.c) del RGPD: el tratamiento es necesario para el cumplimiento de una obligación legal aplicable al responsable del tratamiento: - Real Decreto 933/2021, de 26 de octubre, por el que se establecen las obligaciones de registro documental e información de las personas físicas o jurídicas que ejercen actividades de hospedaje y alquiler de vehículos a motor.
Conservación y tratamiento de los datos: Los datos proporcionados se conservarán mientras no solicite la cancelación de la misma, o durante el tiempo necesario para cumplir con las obligaciones legales y atender las posibles responsabilidades que pudieran derivar del cumplimiento de la finalidad para la que los datos fueron recabados. Sus datos serán cedidos a las diferentes empresas mayoristas con las que la entidad opere, así como a las compañías aéreas, establecimientos hoteleros, empresas de alquiler de vehículos y/o tour operadores, en su caso, con los fines de contratar los servicios de estos o de solicitar información tanto de disponibilidad como de precios. Estos proveedores, dependiendo del país de destino de su viaje, podrán estar ubicados en países que no tengan un nivel de protección de datos similar al existente en la UE, para los cuales la cesión es necesaria para la finalidad de la ejecución de medidas contractuales. Podrán ser cedidos igualmente a otras empresas con las que RUTAS MEIGAS SL trabaje/colabore con el fin de llevar a cabo las gestiones y/o servicios correspondientes. Otros datos no serán cedidos a terceros salvo en los casos en que exista una obligación legal. RUTAS MEIGAS SL no elaborará ningún tipo de "perfil" en base a la información facilitada. No se tomarán decisiones automatizadas en base a perfiles.
Derechos: Usted podrá ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad de datos y a no ser objeto de decisiones individualizadas automatizadas, en relación con los datos objeto del tratamiento, ante el responsable del tratamiento en la dirección RÚA LISBOA 16 BAJO IZDA - 15707 - SANTIAGO DE COMPOSTELA, adjuntando copia de su DNI o documento equivalente. En caso de que no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia Protección de Datos competente, siendo ésta la Agencia Española de Protección de Datos.`
   
    },

    ir_al_camino: 'Más detalles del Camino',

    enviar_consulta: 'Enviar',
    texto_consulta_agencia: 'Envíanos tu consulta y nos pondremos en contacto contigo lo antes posible.',
    consulta_enviada: 'Ya hemos recibido tu consulta, te contactaremos lo antes posible. Gracias!',
                                    
                       
   
   
    },
    
  }
